<template>
  <v-container>
    <div
      :class="[`text-subtitle-1`]"
    >
      <h4>Education(s)</h4>
    </div>
    <v-row
      v-for="(item, i) in education_list"
      :key="i"
    >
      <v-col md="12" cols="12">
        <v-row>
          <v-col
            md="2"
            cols="4"
          >
            School:
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            {{ education_list[i].school_name || '-' }}
          </v-col>
          <v-col
            md="2"
            cols="4"
          >
            Level:
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            {{ education_list[i].level || '-' }}
          </v-col>
          <v-col
            md="2"
            cols="4"
          >
            start_date:
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            {{ education_list[i].start_date || '-' }}
          </v-col>
          <v-col
            md="2"
            cols="4"
          >
            End date:
          </v-col>
          <v-col
            cols="8"
            md="4"
          >
            {{ education_list[i].end_date || '-' }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
        <v-divider></v-divider>
  </v-container>
</template>

<script>
export default {
  name: 'SupporterEducation',
  props: ['education_list', 'remove_education'],
  methods: { },
}
</script>